export const isDarkMode = (theme) => {
  if (theme === "light") {
    return false;
  } else if (theme === "dark") {
    return true;
  } else {
    // 默认跟随系统 dark 模式；若系统 dark 模式未开启，判断时间是否在 22:00 到 6:00 之间
    let isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (!isDark) {
      const now = new Date();
      const hour = now.getHours();
      isDark = hour >= 20 || hour < 6;
    }
    return isDark;
  }
};

export const applyDarkMode = (isDarkMode) => {
  const htmlElement = document.documentElement;
  if (isDarkMode) {
    htmlElement.classList.add("dark");
  } else {
    htmlElement.classList.remove("dark");
  }
};
